import { Member } from 'Shared/types/Member.type';
import { createSelector } from 'reselect';

function getMembers(state): Member[] {
  return state.members;
}

function createParameterSelector(selector) {
  return (_, params) => selector(params);
}

const getUserSlugParam = createParameterSelector(params => params.userSlug);

export const getAllMembers = createSelector([getMembers], members => members);

export const getMemberBySlug = createSelector([getAllMembers, getUserSlugParam], (members, slug) => {
  return members.find(member => member.slug === slug);
});
